export const PROVIDER_NAMES = {
  POSTHOG: 'posthog',
  META_PIXEL: 'metaPixel',
}
